import { computed } from '@nuxtjs/composition-api';
import { sharedRef, useVSFContext } from '@vue-storefront/core';

import getAutomaticDiscounts from './getAutomaticDiscounts';
import {
  UseAutomaticDiscountsError,
  UseAutomaticDiscountsLoading,
  UseAutomaticDiscountsResult,
} from './types';

const useAutomaticDiscounts = (id: string) => {
  const context = useVSFContext();

  const loading = sharedRef(false, `UseAutomaticDiscounts/loading-${id}`);
  const result = sharedRef(null, `UseAutomaticDiscounts-${id}`);
  const error = sharedRef(null, `UseAutomaticDiscounts/error-${id}`);

  const refs = {
    loading,
    result,
    error,
  };

  return {
    getAutomaticDiscounts: getAutomaticDiscounts(context, refs, id),
    loading: computed<UseAutomaticDiscountsLoading>(() => loading.value),
    result: computed<UseAutomaticDiscountsResult>(() => result.value),
    error: computed<UseAutomaticDiscountsError>(() => error.value),
  };
};

export default useAutomaticDiscounts;
